<template>
  <div>
    <ImageCropperContent />
  </div>
</template>

<script setup>
import ImageCropperContent from '../components/ImageCropper/index.vue'
</script>
